import React from "react";

const program = [
  {
    name: "Strategic Location: Experience engineering education in the heart of Chennai, India's tech hub, where innovation meets tradition.",
  },
  {
    name: "Academic Excellence: Choose from 10+ cutting-edge engineering programs designed to meet industry demands.",
  },
  {
    name: "Exceptional Merit Rewards: Earn significant fee waivers based on your performance:",
  },
  {
    name: "State-of-the-Art Infrastructure: Access world-class laboratories, research facilities, and modern learning spaces equipped with the latest technology.",
  },
  {
    name: "Placement Assistance: Guaranteed career support services to help launch your professional journey.",
  },
  {
    name: "Modern Campus Life: Experience a vibrant campus atmosphere that balances academic rigor with personal growth opportunities.",
  },
];

const ProgramHighlights = () => {
  return (
    <div>
      <ul className="pl-4">
        {program.map((data, index) => {
          return (
            <li className="list-disc pb-4 text-[18px]" key={index}>
              {data.name}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default ProgramHighlights;
